module.exports = __webpack_public_path__ + "img/icon111.6919892a.png";